import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about-section" className="py-24 bg-midnight relative overflow-hidden scroll-mt-56">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start mb-20">
          
          {/* Sezione: Associazione Culturale */}
          <div className="relative">
            <div className="mb-8">
              <span className="text-gold font-sans uppercase tracking-[0.4em] text-xs block mb-4">Associazione Culturale</span>
              <h2 className="text-4xl md:text-5xl font-serif text-white mb-6 leading-tight">
                La Bottega delle Voci
              </h2>
              <div className="w-16 h-px bg-gold mb-8" />
            </div>
            <div className="text-lg text-white/90 leading-relaxed space-y-6">
              <p>
                <span className="text-gold">“La Bottega delle Voci”</span>, Associazione Culturale - Musicale di Cattolica è un piccolo coro laboratorio, diretto dal Maestro Fabio Mengucci, composto da circa 15/18 elementi che eseguono brani di polifonia moderna e originale.
              </p>
              <p>
                I brani musicali eseguiti sono tra i più conosciuti della musica italiana dagli anni '40 - '50 (come quelli del Quartetto Cetra) ai giorni nostri (Battisti, Giorgia, Mango...) fino agli evergreen internazionali (Queen, Sting...) ma riarrangiati e rivisti per voci.
              </p>
              <p>
                Non si rifà ai modelli in voga e di moda del momento, ma si ispira alla <span className="text-gold-light">polifonia classica e contrappuntistica</span> applicata ai brani reinterpretati in chiave corale. Le voci non sono ridotte a mere imitazioni degli strumenti musicali ma hanno una loro dignità singola, ognuna con una chiara linea melodica che insieme producono armonie e ritmi accattivanti.
              </p>

              <div className="pt-8 mt-8 border-t border-gold/20">
                <h3 className="text-gold font-serif text-2xl mb-4">Vieni ad ascoltarci</h3>
                <p className="text-white/80 leading-relaxed mb-4">
                  Il Coro Laboratorio <span className="text-gold">"La Bottega delle Voci"</span>, diretto dal M°Fabio Mengucci, in oltre 40 anni di attività ha al suo attivo numerosissime realizzazioni di spettacoli diversi tra i quali ricordiamo: <span className="italic">"Mirabilia", "Amore Baciami", "Nel Blu", "Per Un'ora D'amore", "Schegge di Emozioni"</span>.
                </p>
                <p className="text-white/80 leading-relaxed">
                  Forte di questa tradizione e consapevole del suo ruolo, <span className="text-gold-light"> "La Bottega delle Voci"</span> ha inteso proporre nuovi percorsi che, ponendosi in linea di naturale continuità con le esperienze acquisite, lo caratterizzino come un vero e proprio <span className="text-gold-light">laboratorio vocale</span>.
                </p>
              </div>
            </div>
          </div>

          {/* Sezione: Il nostro percorso */}
          <div className="relative lg:mt-24">
            <div className="p-8 md:p-12 border border-gold/10 bg-white/5 backdrop-blur-sm relative group">
              {/* Corner accents */}
              <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-gold/40 group-hover:w-12 group-hover:h-12 transition-all duration-500" />
              <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-gold/40 group-hover:w-12 group-hover:h-12 transition-all duration-500" />
              
              <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-serif text-white mb-4 leading-tight">
                  Il nostro percorso
                </h2>
                <div className="w-12 h-px bg-gold/50" />
              </div>
              
              <div className="text-lg text-white/80 leading-relaxed space-y-6">
                <p>
                  In base alla disponibilità di spazio, spesso il coro è accompagnato da <span className="text-gold">musicisti professionisti</span> (flauto traverso, pianoforte, contrabbasso e percussioni) con arrangiamenti appositamente scritti per integrarsi al meglio con le voci e rendere ancora più completo e coinvolgente l'ascolto.
                </p>
                <p>
                  Prosegue la rappresentazione dello spettacolo più recente <span className="italic">“Schegge di Emozioni”</span>. I brani sono vocali cantati a cappella e strumentali, italiani e non, riarrangiati a quattro e più voci in maniera originale, appositamente per il Coro la Bottega delle Voci.
                </p>
                <p className="pt-4 border-t border-gold/10 text-lg">
                  Recentemente sono entrati in repertorio pezzi famosi e di grande effetto come, <span className="italic">“Africa”</span> dei Toto, “How deep is your love” dei Bee Gees, “Mamma mia” degli Abba e “Vacanze romane” dei Matia Bazar.
                </p>

                <div className="pt-8 mt-8 border-t border-gold/20">
                  <h3 className="text-gold font-serif text-2xl mb-4">Cosa vi proponiamo</h3>
                  <p className="text-white/80 leading-relaxed">
                    Siamo in grado di indirizzare la polifonia non solo verso il recupero-riproduzione di brani tratti dal repertorio classico, ma anche verso <span className="text-gold">forme inedite ed originali di musica contemporanea</span>. Oramai è di fatto una delle realtà più qualificate ed innovative, come laboratorio musicale-vocale, della provincia di Rimini.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* TASTO SCORRI VERSO CONCERTI */}
        <div className="flex flex-col items-center justify-center pt-8">
          <div 
            onClick={() => document.getElementById('concerts-section')?.scrollIntoView({ behavior: 'smooth' })}
            className="flex flex-col items-center group cursor-pointer"
          >
            <div className="relative flex items-center justify-center w-14 h-14 mb-3">
              <div className="absolute inset-0 rounded-full border border-gold opacity-20 animate-ping" />
              <div className="absolute inset-0 rounded-full border border-gold/40 group-hover:border-gold transition-all duration-300" />
              <svg className="w-6 h-6 text-gold animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ animationDuration: '2s' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
            <span className="text-gold text-[10px] uppercase tracking-[0.4em] opacity-60 group-hover:opacity-100 transition-opacity">
              Agenda Concerti
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;